import React, { Component } from "react";
import "./Loading.scss"

class Loading extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    render() {
        return (
            // <div className="loading" style={{ display: (this.props.showLoading ? "block" : "none") }}>
            <div className="loading" style={{ display: "none" }}>
                <div className="loader" id="loader-1"></div>
            </div>
        );
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/Components/Services/Loading/Loading.jsx